import OtherTicketingSystem from './OtherTicketingSystem'

export default OtherTicketingSystem
